<template>
  <v-container>
    <v-layout column>
      <v-layout row>
        <v-flex xs12 md6>
          <v-select
            :items="clients"
            item-text="name"
            item-value="id"
            hint="Vincular um cliente a este ciclo"
            v-model="client"
            required
            return-object
            persistent-hint
            clearable
            @click:clear="resetClearIconCb"
            :disabled="disabledClient || (clients.length === 0)"
            no-data-text="Nenhuma registro encontrado"
            label="Selecione um cliente"></v-select>
        </v-flex>
        <v-flex xs12 md6>
          <v-select
            :items="cycles"
            v-model="cycleId"
            item-text="start_date"
            item-value="id"
            required
            hint="Vincular um ciclo a este chamado"
            label="Selecione um ciclo"
            persistent-hint
            :disabled="cycles && cycles.length === 0"
            v-if="cycles && cycles.length > 0">
            <template slot="selection" slot-scope="data">
              {{ data.item.name }}
            </template>
            <template slot="item" slot-scope="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ data.item.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <small>{{ data.item.start_date | prDate }} até {{ data.item.end_date | prDate }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout row v-if="totalCycle">
        <v-flex xs12 md4>
          <v-card class="primary--text card-border">
            <v-card-title primary-title>
              <div class="full-width">
                <div class="headline">Horas do Ciclo</div>
                <v-divider></v-divider>
                <div class="display-3 text-md-right">
                  {{ totalCycle ? totalCycle + 'h' : '--' }}
                </div>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 md4>
           <v-card class="orange--text card-border">
            <v-card-title primary-title>
              <div class="full-width">
                <div class="headline">Horas Utilizadas</div>
                <v-divider></v-divider>
                <div class="display-3 text-md-right">
                  {{ used ? convertMinutesToHours(used) + 'h' : '--' }}
                </div>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 md4>
           <v-card :class="setClassBalance()">
            <v-card-title primary-title>
              <div class="full-width">
                <div class="headline">Saldo Atual</div>
                <v-divider></v-divider>
                <div class="display-3 text-md-right">
                  {{ convertMinutesToHours(balanceNegative()) }}h
                </div>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 md12 v-if="calledHistories.length > 0">
          <data-table-called-history :data-value="calledHistories" :cycle-id="cycleId">
          </data-table-called-history>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 md12>
          <ve-pie
            :data="chartData"
            :settings="chartSettings"
            :legend-visible="false"
            :loading="loading"
            :events="loadReportDetail"></ve-pie>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md12>
          <v-alert
            :value="showAlert"
            type="error">
            Não existem clientes cadastrados no sistema.
          </v-alert>
          <v-alert :value="(!totalCycle && cycles && cycles.length === 0)" type="error">
            Nenhum ciclo cadastrado para este cliente.
          </v-alert>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import 'v-charts/lib/style.css';
import ReportService from '@/features/report/ReportService';
import ClientService from '@/features/client/ClientService';
import CycleService from '@/features/cycle/CycleService';
import CallHistoryService from '@/features/call-histories/CallHistoryService';
import DataTableCalledHistory from '@/features/report/DataTableCalledHistory';
import DataTableDialog from '@/features/report/DataTableDialog';
import CalledService from '@/features/called/CalledService';
import UserService from '@/features/user/UserService';

export default {
  name: 'cycle-consolidated',
  components: {
    DataTableCalledHistory,
  },
  data() {
    return {
      showAlert: false,
      isBalanceNegative: false,
      cycle: null,
      loading: false,
      dataEmpty: true,
      totalCycle: null,
      used: null,
      balance: null,
      chartSettings: {
        itemStyle: {
          normal: {
            color: (param) => {
              const colors = ['#DC3C37', '#2AB249'];
              return colors[param.dataIndex];
            },
          },
        },
        radius: 150,
        selectedMode: 'single',
        dataType: v => this.convertMinutesToHours(v),
      },
      loadReportDetail: {
        click: (e) => {
          if (e.dataIndex === 0) {
            this.showDataTableHistory(this.showDataTableHistoryDialog.bind(this));
          }
        },
      },
      calledHistories: [],
      chartData: null,
      clients: [],
      client: null,
      cycles: null,
      cycleId: null,
      calledSetvice: new CalledService(),
      clientService: new ClientService(),
      reportService: new ReportService(),
      cycleService: new CycleService(),
      callHistoryService: new CallHistoryService(),
      disabledClient: false,
    };
  },
  watch: {
    client(value) {
      if (value) {
        this.reset();
        const params = {
          client_id: value.id,
          active: 'sim',
        };
        this.cycleService.query(params).then((data) => {
          this.cycles = data;
          if (this.cycles.length === 0) this.loading = false;
        });
      }
    },
    cycleId() {
      if (this.cycleId) {
        this.loading = true;
        this.searchData();
      }
    },
  },
  created() {
    const user = this.$store.state.currentUser;
    if (!UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.client = user.client;
      this.disabledClient = true;
    }
    this.loadClient();
  },
  methods: {
    searchData() {
      const options = {
        params: { cycleID: this.cycleId },
      };
      this.reportService.request('GET', 'cycle-consolidated', null, options)
        .then((response) => {
          this.totalCycle = response.data.hour;
          this.used = response.data.used;
          this.balance = response.data.balance;
          this.loading = false;
          this.dataEmpty = false;
          this.loadDataChart();
        });
    },
    loadClient() {
      this.clientService.query().then((data) => {
        this.clients = data;
        if (this.clients.length === 0) {
          this.showAlert = true;
        }
      });
    },
    loadDataChart() {
      this.showDataTableHistory();
      this.chartData = {
        columns: ['name', 'value'],
        rows: [
          { name: 'Horas Utilizadas', value: this.used },
          { name: 'Saldo de Horas', value: this.balanceNegative() },
        ],
      };
    },
    balanceNegative() {
      const hour = this.totalCycle * 60;
      let balance;
      this.isBalanceNegative = false;
      if (!this.used) {
        balance = hour;
      } else if (this.used && this.used < hour) {
        balance = (hour - this.used);
      } else if (this.used && this.used > hour) {
        balance = 0;
        this.isBalanceNegative = true;
      } else {
        balance = this.balance;
      }
      return balance;
    },
    reset() {
      this.totalCycle = null;
      this.used = null;
      this.balance = null;
      this.cycles = null;
      this.cycleId = null;
      this.chartData = {};
    },
    resetClearIconCb() {
      this.reset();

      this.client = null;
    },
    convertMinutesToHours(value) {
      let hourAndMinutes = '00:00';
      if (value) {
        const hours = (Math.floor(value / 60)).toString().padStart(2, '0');
        const minutes = (value % 60).toString().padStart(2, '0');
        hourAndMinutes = `${hours}:${minutes}`;
      }
      return hourAndMinutes;
    },
    setClassBalance() {
      let klass = 'card-border';
      if (!this.balance || this.isBalanceNegative) {
        klass = `${klass} error--text`;
      } else {
        klass = `${klass} success--text`;
      }
      return klass;
    },
    async showDataTableHistory(callback) {
      const filter = { cycle_id: this.cycleId, isReport: true };
      this.calledHistories = await this.calledSetvice.query(filter);
      if (callback) callback(this.calledHistories);
    },
    showDataTableHistoryDialog(dataValue) {
      this.$dialog.component(
        DataTableDialog,
        {
          closeWithEsc: false,
          widget: false,
          width: '60%',
          dataValue,
          cycleId: this.cycleId,
        });
    },
  },
};
</script>
<style>
  .full-width {
    width: 100%;
  }
  .card-border {
    border: 1px solid #ccc;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/features/report/CycleConsolidated.vue